<on-page-title
    [title]="'accountant-expert.title' | translate"
    icon="fa-handshake"
></on-page-title>

<form
    (ngSubmit)="updateSettings(supportEmail.value, logoImage.files[0])"
    *ngIf="currentCompany$ | async as company"
>
    <div class="row mb-5 mt-4">
        <div class="mb-3 col-6 form-group">
            <label for="supportEmail" class="form-label">{{
                'accountant-expert.support-email' | translate
            }}</label>
            <input
                #supportEmail
                type="email"
                class="form-control"
                id="supportEmail"
                placeholder="name@example.com"
                [(ngModel)]="company.Settings.SupportEmail"
                [ngModelOptions]="{ standalone: true }"
            />
        </div>
        <div class="mb-3 col-5 form-group">
            <label for="companyImage" class="form-label">{{
                'accountant-expert.company-image' | translate
            }}</label>
            <img
                *ngIf="company.Settings?.CompanyLogoUrl"
                id="currentCompanyImage"
                [src]="company.Settings.CompanyLogoUrl"
                title="Logo"
                [alt]="'Logo ' + company.Name"
                class="img-thumbnail"
            />
            <input
                #logoImage
                type="file"
                class="form-control"
                id="companyImage"
                accept="image/*"
            />
        </div>
        <div class="text-center">
            <button type="submit" class="btn btn-primary">
                {{ 'accountant-expert.save' | translate }}
            </button>
        </div>
    </div>
</form>
<hr />
<div class="text-end">
    <button
        routerLink="/accountant_expert/create_company"
        class="btn btn-primary create-company-button"
    >
        {{ 'accountant-expert.create-company' | translate }}
    </button>
</div>
<ag-grid-angular #agGridCompanies class="ag-theme-material"> </ag-grid-angular>
